export default "__VITE_ASSET__3c896118__"